import psHttp from '@patsnap/common-ps-http';
import { workspaceApiUrlPrefix } from '../../config/constants';
export function postVote(vote, params) {
    return psHttp({
        url: `${workspaceApiUrlPrefix}/field/vote`,
        method: 'POST',
        data: {
            ...params,
            vote,
        },
    }).then(({ data }) => {
        return data || {};
    });
}
export function getVoteCommentsInfo(params) {
    return psHttp({
        url: `${workspaceApiUrlPrefix}/field/vote-info`,
        method: 'POST',
        data: {
            ...params,
        },
    }).then(({ data }) => {
        return data.data || {};
    });
}
const cacheVoteToggleState = new Map();
function genVoteFieldUuid(params) {
    return `voteInit-${params.field_id} - ${params.folder_id}`;
}
export function voteInit(params) {
    const uuid = genVoteFieldUuid(params);
    return psHttp({
        url: `${workspaceApiUrlPrefix}/field/${params.field_id}/vote-switch`,
        method: 'GET',
        cache: true,
        uuid,
        params: {
            folder_id: params.folder_id,
        },
    }).then(({ data }) => {
        return data.data || {};
    }).then(d => {
        if (cacheVoteToggleState.has(uuid)) {
            d.vote_switch = cacheVoteToggleState.get(uuid);
        }
        else {
            cacheVoteToggleState.set(uuid, d.vote_switch);
        }
        return d;
    });
}
export function logVoteToggleState(on, params) {
    const uuid = genVoteFieldUuid(params);
    cacheVoteToggleState.set(uuid, on);
    return psHttp({
        url: `${workspaceApiUrlPrefix}/field/${params.field_id}/vote-switch`,
        method: 'POST',
        data: {
            folder_id: params.folder_id,
            vote_switch: on,
        },
    }).then(({ data }) => {
        return data.data || {};
    });
}
